/* stylelint-disable */

/*
 * This file contains global styling for HTML elements only (with the exception
 * of `#root`). Styles for third-party components are imported separately and
 * merged into `createGlobalStyle`: we want to move these to `styled-components`
 * as support is added.
 *
 */

import { createGlobalStyle } from 'styled-components/macro';
import { colors } from 'css/constants';

import FlatpickrStyles from 'css/flatpickrStyles';
import ReactToggleStyles from 'css/reactToggleStyles';
import ToastrStyles from 'css/toastrStyles';
import TabStyles from './tabStyles';
import FormStyles from './formStyles';

const GlobalStyles = createGlobalStyle`

  html,
  body {
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
    background: ${(props) => props.theme.background};
    color: ${(props) => props.theme.text};
  }

  html {
    overflow: hidden;
    line-height: ${(props) => props.theme.lineHeight};
    font-size: ${(props) => props.theme.fontSize};
  }

  #root {
    height: 100%;
  }

  body,
  button,
  input,
  label {
    font-family: ${(props) => props.theme.fontFamily};
    color: ${(props) => props.theme.text}
  }

  a {
    color: ${colors.blue};
  }

  a:hover {
    text-decoration: none;
  }

  p {
    margin-top: 0;
    margin-bottom: 1rem;
  }

  input::placeholder {
    color: ${colors.midGrey};
  }

  h1, h2, h3, h4, h5 {
    margin: 0;
    margin-bottom: 1rem;
  }

  table td, table th {
    vertical-align: middle;
  }

  table th {
    white-space: nowrap;
  }

  ${ReactToggleStyles}
  ${FlatpickrStyles}
  ${ToastrStyles}
  ${TabStyles}
  ${FormStyles}
`;

export default GlobalStyles;
